export function footerAccordion() {
  const toggleContainers = document.querySelectorAll(".toggle-wrapper");

  function toggleElementVisibility() {
    toggleContainers.forEach((container) => {
      const heading = container.querySelector(".toggle-heading");
      const element = container.querySelector(".toggle-element");

      if (window.innerWidth >= 1024) {
        element.style.maxHeight = element.scrollHeight + "px";
        heading.removeEventListener("click", toggleMobileBehavior);
      } else {
        element.style.maxHeight = "0px";
        heading.addEventListener("click", toggleMobileBehavior);
      }
    });
  }

  function toggleMobileBehavior(event) {
    const heading = event.target;
    const container = heading.parentElement;
    const element = container.querySelector(".toggle-element");

    if (!heading.classList.contains("active")) {
      heading.classList.add("active");
    }

    if (
      element.style.maxHeight === "0px" ||
      getComputedStyle(element).maxHeight === "0px"
    ) {
      element.style.maxHeight = element.scrollHeight + "px";
    } else {
      element.style.maxHeight = "0px";
      heading.classList.remove("active");
    }
  }

  window.addEventListener("resize", toggleElementVisibility);

  toggleElementVisibility();
}
